import { connect } from 'react-redux';
import noop from 'lodash/noop';

import MediaLibraryMain from './media_library.main.ui.jsx';


const mapStateToProps = (state) => {
  return {};
};


const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps

)(MediaLibraryMain);
